/**
 * @module:  检查项相关store
 * @author: Liang Huang 
 * @date: 2019-12-12 09:36:21 
 */
import { ajax } from '@clouderwork/ywk';
import { observable, action, flow } from 'mobx';
import { ICheckModule } from '@src/entity/company/task';
import { ICheckItem } from '@src/entity/okr/task';

class Check {
  @observable subStatus = 'init';
  @observable checkStatus = 'init';
  /**
   * 临时检查项
   */
  @observable tempCheckModule: ICheckModule | null = null;
  /**
   * 子检查项创建时检查模块
   */
  @observable createSubModule: ICheckModule | null = null;
  /**
   * 是创建:1 or 编辑子检查项: 2
   */
  @observable createOrEditSub: number = -1;
  /**
   * 当前子检查项数据
   */
  @observable curSubCheck: ICheckItem | null = null;
  /**
   * 创建子检查项
   */
  @action.bound
  createSub = flow(function*(
    this: Check,
    params: {
      content: any;
      task_id: number;
      check_module_id: number;
    }
  ) {
    if (this.subStatus === 'pending') return;
    this.subStatus = 'pending';
    try {
      const res = yield ajax.post('/company/api/tasks/check', {
        content: params.content,
        task_id: params.task_id,
        check_module: params.check_module_id
      });
      this.subStatus = 'done';
      return res;
    } catch (error) {
      this.subStatus = 'error';
      return error;
    }
  });
  /**
   * 编辑子检查项
   */
  @action.bound
  putSub = flow(function*(
    this: Check,
    params: {
      check_module_id: number;
      content: string;
      task_id: number;
      check_id: number;
    }
  ) {
    if (this.subStatus === 'pending') return;
    this.subStatus = 'pending';
    try {
      const res = yield ajax.putPureJson(
        `/company/api/tasks/check/${params.check_id}`,
        {
          task_id: params.task_id,
          content: params.content,
          check_module: params.check_module_id
        }
      );
      this.subStatus = 'done';
      return res;
    } catch (error) {
      this.subStatus = 'error';
      return error;
    }
  });
  /**
   * 删除检查项
   */
  @action.bound
  deleteSub = flow(function*(this: Check, { check_id }) {
    if (this.subStatus === 'pending') return;
    this.subStatus = 'pending';

    try {
      const res = yield ajax.deletePureJson(
        `/company/api/tasks/check/${check_id}`
      );
      this.subStatus = 'done';
      return res;
    } catch (error) {
      this.subStatus = 'error';
      return error;
    }
  });
  /**
   * 完成检查项
   */
  @action.bound
  finishSub = flow(function*(
    this: Check,
    params: { check_id: number; is_finish: 1 | 0 }
  ) {
    if (this.subStatus === 'pending') return;
    this.subStatus = 'pending';

    try {
      const res = yield ajax.post(
        `/company/api/tasks/check/finish/${params.check_id}`
      );
      this.subStatus = 'done';
      return res;
    } catch (error) {
      this.subStatus = 'error';
      return error;
    }
  });
  /**
   * 删除检查清单
   */
  @action.bound
  deleteCheck = flow(function*(
    this: Check,
    params: { task_id: number; check_module_id: number }
  ) {
    if (this.checkStatus === 'pending') return;
    this.checkStatus = 'pending';

    try {
      const res = yield ajax.deletePureJson(
        `/company/api/tasks/check/module/${params.check_module_id}`,
        {
          task_id: params.task_id
        }
      );
      this.checkStatus = 'done';
      return res;
    } catch (error) {
      this.checkStatus = 'error';
      return error;
    }
  });
  /**
   * 创建检查清单
   */
  @action.bound
  createCheck = flow(function*(
    this: Check,
    params: { name: string; task_id: number }
  ) {
    if (this.checkStatus === 'pending') return;
    this.checkStatus = 'pending';

    try {
      const res = yield ajax.post('/company/api/tasks/check/module', {
        name: params.name,
        task_id: params.task_id
      });
      this.checkStatus = 'done';
      return res;
    } catch (error) {
      this.checkStatus = 'error';
      return error;
    }
  });
  /**
   * 编辑检查清单
   */
  @action.bound
  putCheck = flow(function*(
    this: Check,
    params: {
      name: string;
      check_module_id: number;
      task_id: number;
    }
  ) {
    if (this.checkStatus === 'pending') return;
    this.checkStatus = 'pending';

    try {
      const res = yield ajax.putPureJson(
        `/company/api/tasks/check/module/${params.check_module_id}`,
        {
          name: params.name,
          task_id: params.task_id
        }
      );
      this.checkStatus = 'done';
      return res;
    } catch (error) {
      this.checkStatus = 'error';
      return error;
    }
  });
}

export default Check;
